import axios from '../../../utils/api'
import { CLEAR_CADASTRO, SET_CADASTRO_ORIGINAL } from '../../mutation-types'

const getters = {
  cadastroOriginal: state => state.cadastroOriginal
}

const mutations = {
  [CLEAR_CADASTRO] (state, emptyCadastro) {
    Object.assign(state, emptyCadastro)
  },
  [SET_CADASTRO_ORIGINAL] (state, cadastroOriginal) {
    Object.assign(state.cadastroOriginal, cadastroOriginal)
  }
}

const actions = {
  async salvarCadastro ({ commit }, cadastro) {
    const result = await axios({
      method: 'POST',
      url: 'cadastro/salvar',
      data: {
        ...cadastro
      }
    })

    return result
  },

  async finalizarCadastro ({ commit }, idCadastro) {
    const result = await axios({
      method: 'PUT',
      url: `cadastro/finalizar/${idCadastro}`,
      timeout: 180000,
      error: true
    })

    return result
  },

  async findByIdCadastro ({ commit }, idCadastro) {
    const result = await axios({
      method: 'GET',
      url: `cadastro/${idCadastro}`
    })

    return result
  },

  async finalizar ({ commit }, { idCadastro, emptyCadastro }) {
    try {
      await axios({
        method: 'PUT',
        url: `cadastro/finalizar/${idCadastro}`
      })
      await commit('CLEAR_CADASTRO', emptyCadastro)
    } catch (error) {
      throw error
    }
  },

  async responderVinculo ({ commit }, { protocolo, isAceito }) {
    return axios({
      method: 'PUT',
      url: 'cadastro/responderVinculo',
      data: {
        protocolo,
        isAceito
      }
    })
  },

  async removeByPath ({ commit }, dados) {
    await axios({
      method: 'POST',
      url: 'cadastro/removeByPath',
      data: dados
    })
  },

  async prepararEdicaoByIdProcesso ({ commit }, idProcesso) {
    return axios({
      method: 'POST',
      url: `cadastro/prepararEdicao/processo/${idProcesso}`
    })
  },

  async removeCadastroById ({ commit }, idCadastro) {
    await axios({
      method: 'DELETE',
      url: `cadastro/${idCadastro}`
    })
  }
}

export default {
  namespaced: true,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cadastro/cadastro.js